import { render } from "./ebayExclusions.vue?vue&type=template&id=7a8b13d5&scoped=true"
import script from "./ebayExclusions.vue?vue&type=script&lang=js"
export * from "./ebayExclusions.vue?vue&type=script&lang=js"

import "./ebayExclusions.vue?vue&type=style&index=0&id=7a8b13d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8b13d5"]])

export default __exports__